import { defineType } from "sanity";

export default defineType({
  name: "shorexSelection",
  title: "Shorex selection",
  type: "object",
  preview: {
    select: {
      name: "name"
    },
    prepare({ name }) {
      return {
        title: `${name}`
      };
    }
  },
  fields: [
    {
      name: "name",
      title: "Category Name",
      type: "string",
      readOnly: true
    },
    {
      name: "total",
      title: "Total",
      type: "number",
      readOnly: true
    },
    {
      name: "shorexes",
      title: "Shorexes",
      type: "array",
      of: [{ type: "confirmedShorex" }],
      readOnly: true
    }
  ]
});
